import { useQuery, useQueryClient } from "@tanstack/vue-query";
import { watch, Ref } from "vue";
import { FinOneMarcaVehiculoAction } from "../../actions/marcaVehiculosActions";

export function useMarcaVehiculoFindOne(id: Ref<string>) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ["MarcaVehiculoFindOne", id],
    queryFn: () => FinOneMarcaVehiculoAction(id.value),
    enabled: () => !!id.value,
    staleTime: 60 * 1000,
  });

  // Si cambia el ID, hacer prefetch
  watch(id, (newId) => {
    if (newId) {
      queryClient.prefetchQuery({
        queryKey: ["MarcaVehiculoFindOne", newId],
        queryFn: () => FinOneMarcaVehiculoAction(newId),
      });
    }
  });

  return {
    ...query,
  };
}
